import React, {useState} from "react";
import StyledForm from "./Form.styled";
import validateForm from "./validateForm";
import FormSubmitModal from "./FormSubmitModal";

const Form = (props) => {
    console.log(`In Form... input props: ${JSON.stringify(props, ["id", "name", "data-name", "method", "className"])}`);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState(null);
    const [modalTitle, setModalTitle] = useState(null);
    const [apiResponseStatus, setApiResponseStatus] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    console.log(`In Form... state: name=${name} email=${email} subject=${subject} message=${message} error=${error}
     modelTitle=${modalTitle} apiResponseStatus=${apiResponseStatus} isOpen=${isOpen}`);

    const showModal = () => {
        console.log(`in Form.showModal before setting to true...isOpen=${isOpen}`);
        setIsOpen(true);
    };

    const hideModal = () => {
        console.log(`in Form.hideModal before setting to false...isOpen=${isOpen}`);
        setIsOpen(false);
    };

    const resetForm = () => {
        setName('');
        setEmail('');
        setSubject('');
        setMessage('');
        setError(null);
    }

    const handleNameInputChange = (e) => {
        console.log(`In handleNameInputChange name=${e.target.value}`);
        setName(e.target.value)
    }

    const handleEmailInputChange = (e) => {
        console.log(`In handleEmailInputChange email=${e.target.value}`);
        setEmail(e.target.value)
    }

    const handleSubjectInputChange = (e) => {
        console.log(`In handleSubjectInputChange subject=${e.target.value}`);
        setSubject(e.target.value)
    }

    const handleMessageInputChange = (e) => {
        console.log(`In handleMessageInputChange message=${e.target.value}`);
        setMessage(e.target.value)
    }

    const postData = () => {

        const fields =
            {
                "fields": {
                    "Name": `${name}`,
                    "Email Address": `${email}`,
                    "Subject": `${subject}`,
                    "Message": `${message}`
                }
            }

        const requestOptions = {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${process.env.GATSBY_AIRTABLE_KEY}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(fields)
        };

        fetch(`https://api.airtable.com/v0/${process.env.GATSBY_AIRTABLE_DB}/ContactForm`, requestOptions)
            .then((response) => {
                console.log(`api response status=${response.status} from api url=${response.url}`)
                if (!response.ok)
                    throw new Error(`HTTP error occurred sending message to server:  status=${response.status}`);
                return response.json();
            })
            .then((data) => {
                console.log(`api response airtable data=${JSON.stringify(data)}`)
                resetForm();
                setModalTitle(`Your message was sent!`);
                setApiResponseStatus(`Thank you for contacting me.  I will get back to you soon.`);
                showModal();
            })
            .catch((error) => {
                console.error(error.message);
                setModalTitle(`Unable to send message!`);
                setApiResponseStatus(`${error.message}`);
                showModal();
            })
    }

    const handleSubmit = (e) => {
        console.log(`In handleSubmit...will be sending form data if validation passes`);

        //prevent page refresh default behavior when a form is submitted
        e.preventDefault();
        const resultError = validateForm({name, email, subject, message});

        if (resultError !== null) {
            setError(resultError);
            console.log(`From validateForm...resultError= ${resultError}`);
            return;
        }

        postData();

        console.log(`In handleSubmit...state: name=${name} email=${email} subject=${subject} message=${message} error=${error}
     modelTitle=${modalTitle} apiResponseStatus=${apiResponseStatus} isOpen=${isOpen}`);
    };

    return (
        <>
            <StyledForm onSubmit={handleSubmit}>
                <label htmlFor="name" className="contact_form-label">Name</label>
                <input type="text" className="contact_field w-input" maxLength="256" name="name"
                       data-name="Name" placeholder="" id="name" required="" value={name}
                       onChange={handleNameInputChange}/>
                <label htmlFor="email" className="contact_form-label">Email Address</label>
                <input type="email" className="contact_field w-input" maxLength="256" name="email"
                       data-name="Email" placeholder="" id="email" required="" value={email}
                       onChange={handleEmailInputChange}/>
                <label htmlFor="subject" className="contact_form-label">Subject</label>
                <input type="text" className="contact_field w-input" maxLength="256" name="field"
                       data-name="Field" placeholder="" id="subject" required="" value={subject}
                       onChange={handleSubjectInputChange}/>
                <label htmlFor="message" className="contact_form-label">Message</label>
                <textarea placeholder="Type your message here" maxLength="5000" id="message"
                          name="field" required="" data-name="field" className="contact_field w-input mb-3"
                          value={message} onChange={handleMessageInputChange}/>
                {error && (
                    <div className="form_validation_error mb-3">
                        {error}
                    </div>
                )}
                <input type="submit" value="Contact Me" className="btn btn-primary"/>
            </StyledForm>
            <FormSubmitModal onClose={hideModal}
                             show={isOpen}
                             title={modalTitle}
                             message={apiResponseStatus}/>
        </>
    )
}

export default Form;